// Generated by ReScript, PLEASE EDIT WITH CARE


let $$throw = (function(msg) {
    throw new Error(msg);
  });

let make = (function(msg) {
    return new Error(msg);
  });

let message = (function(e) {
    return e && e.message ? e.message : undefined;
  });

export {
  $$throw,
  make,
  message,
}
/* No side effect */
